export default "__VITE_ASSET__B7jscE11__"